// extracted by mini-css-extract-plugin
export default {"centerText":"check-system-permissions-message-module__centerText--zDMIh","wrapper":"check-system-permissions-message-module__wrapper--yBexp"};